import { render } from "./legup-tour.vue?vue&type=template&id=9aa37754"
import script from "./legup-tour.vue?vue&type=script&lang=js"
export * from "./legup-tour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__